import { render, staticRenderFns } from "./BatchCreationForm.vue?vue&type=template&id=05a187f9&scoped=true&"
import script from "./BatchCreationForm.vue?vue&type=script&lang=ts&"
export * from "./BatchCreationForm.vue?vue&type=script&lang=ts&"
import style0 from "./BatchCreationForm.vue?vue&type=style&index=0&id=05a187f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a187f9",
  null
  
)

export default component.exports